import { render, staticRenderFns } from "./stocktaking.vue?vue&type=template&id=d28b45b4&scoped=true"
import script from "./stocktaking.vue?vue&type=script&lang=ts"
export * from "./stocktaking.vue?vue&type=script&lang=ts"
import style0 from "./stocktaking.vue?vue&type=style&index=0&id=d28b45b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28b45b4",
  null
  
)

export default component.exports